import AdminSidebarLayout from '@/layouts/admin/admin-sidebar-layout';
import { RegistryProvider } from '@/contexts/RegistryContext';
import { Outlet } from 'react-router';

export function AdminLayout() {
    return (
        <RegistryProvider>
            <AdminSidebarLayout>
                <Outlet />
            </AdminSidebarLayout>
        </RegistryProvider>
    );
}

export default AdminLayout;
